import React, { Component } from 'react';

import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";

import { 
  Box,
  Grid,
} from '@material-ui/core';

import CustomInput from '../../../components/CustomFields/CustomInput.jsx';
import CustomButton from '../../../components/CustomFields/CustomButton.jsx';

export class ItemsInJobForm extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let isLoading = ((props.isLoading === true || props.isLoading === false) ? props.isLoading : false);
    let item = (props.item) ? props.item : null;
    
    let description = (item && item.description) ? item.description : '';
    let quantity = (item && item.quantity) ? item.quantity : '';
    let uom = (item && item.uom) ? item.uom : '';
    let weight = (item && item.weight) ? item.weight : '';
    let remarks = (item && item.remarks) ? item.remarks : '';

    this.state = {
        isLoading: isLoading,
        item: item,

        description: description,
        descriptionValidated: false,
        quantity: quantity,
        quantityValidated: false,
        uom: uom,
        // uomValidated: false,
        weight: weight,
        // weightValidated: false,
        remarks: remarks,
        //remarksValidated: false,
    }
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading !== this.state.isLoading) {
        let isLoading = ((nextProps.isLoading === true || nextProps.isLoading === false) ? nextProps.isLoading : false);
        this.setState({
            isLoading: isLoading
        });
    }
    if (nextProps.item !== this.state.item) {
        let item = (nextProps.item) ? nextProps.item : null;
        this.setState({
            item: item
        });
    }
  }


  /* FORM */
  setForm = () => {
    let weightLabel = localStorage.getItem('Weight') !== null ? localStorage.getItem('Weight') : 'Weight (lb)';
    if (weightLabel === 'kilogram (kg)') weightLabel = 'Weight (kg)';
    else if (weightLabel === 'pound (lb)') weightLabel = 'Weight (lb)';

    return <Box>
        <Grid container>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Item Name'}
                        placeholder={'Brief about the item....'}
                        value={this.state.description}
                        error={this.state.descriptionValidated}
                        multiline={true}
                        rows={3}
                        required={true}
                        autoFocus={true}
                        onChange={(e) => {
                            this.setState({
                                description: e.target.value,
                                descriptionValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Quantity'}
                        placeholder={'Quantity'}
                        type={'number'}
                        value={this.state.quantity}
                        error={this.state.quantityValidated}
                        required={true}
                        onChange={(e) => {
                            this.setState({
                                quantity: e.target.value,
                                quantityValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'UOM'}
                        placeholder={'Enter uom'}
                        value={this.state.uom}
                        // error={this.state.uomValidated}
                        // required={true}
                        onChange={(e) => {
                            this.setState({
                                uom: e.target.value,
                                // uomValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={weightLabel}
                        placeholder={'Enter weight of the item'}
                        type={'number'}
                        value={this.state.weight}
                        // error={this.state.weightValidated}
                        // required={true}
                        onChange={(e) => {
                            this.setState({
                                weight: e.target.value,
                                // weightValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Remarks'}
                        placeholder={'Message here....'}
                        value={this.state.remarks}
                        error={this.state.remarksValidated}
                        multiline={true}
                        rows={3}
                        //required={true}
                        onChange={(e) => {
                            this.setState({
                                remarks: e.target.value,
                                //remarksValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  
  setButtons = () => {
    return <Box>
        <Grid container alignItems={'center'} >
            <Box clone textAlign={'right'} pr={2}>
                <Grid item xs={true}>
                    <CustomButton 
                        onClick={() => {
                            if(this.props.onClose){
                                this.props.onClose();
                            }
                        }}
                    >
                        Cancel
                    </CustomButton>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={'auto'}>
                    <CustomButton 
                        type={'submit'}
                        color={'secondary'} 
                        isLoading={this.state.isLoading}
                    >
                        {(this.state.item ? 'Save' : 'Save')}
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  /* END FORM */


  /* SUBMIT */
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
        isLoading: true,
    });

    const form = e.currentTarget;

    this.setState({
        descriptionValidated: false,
        quantityValidated: false,
        // uomValidated: false,
        // weightValidated: false,
        //remarksValidated: false,
    });
    
    if(this.state.description === ''){
      this.setState({
        descriptionValidated: true
      });
    }
    if(this.state.quantity === ''){
      this.setState({
        quantityValidated: true
      });
    }
    // if(this.state.uom === ''){
    //   this.setState({
    //     uomValidated: true
    //   });
    // }
    // if(this.state.weight === ''){
    //   this.setState({
    //     weightValidated: true
    //   });
    // }
    // if(this.state.remarks === ''){
    //   this.setState({
    //     remarksValidated: true
    //   });
    // }


    if (form.checkValidity() === true) {
        if(this.props.onSave){
            this.props.onSave((this.state.item ? true : false), this.getForm());
        }
    } else {
        this.setState({
            isLoading: false
        });
    }
  }

  
  getForm = () => {
    let data = {
        description: this.state.description,
        quantity: this.state.quantity,
        uom: this.state.uom,
        weight: this.state.weight,
        remarks: this.state.remarks,
    }

    return data;
  }
  /* END SUBMIT */
      
  render() {
    return <Box>
        <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container>
                <Box clone pt={2} pb={2}>
                    <Grid item xs={12}>
                        {this.setForm()}
                    </Grid>
                </Box>
                <Box clone>
                    <Grid item xs={12}>
                        {this.setButtons()}
                    </Grid>
                </Box>
            </Grid>
        </form>
    </Box>
  }
}

export default ItemsInJobForm;